import { convertToRaw } from 'draft-js'
import { stateToHTML } from 'draft-js-export-html'
import { tokenize, getDefaultRichStyleConfig } from './utils.js'

/**
 * @param config, {Object} collection of named params
 *   @param isEmail, {Boolean} is this message setting an email? If false, it is
 *     assumed to be a plain text SMS or phone call.
 */
export const serializeSetting = (bodyState, subjectState, { isEmail }) => {
  if (!isEmail) {
    return {
      body: _serializePlainBody(bodyState),
    }
  }
  const currSubjectContent = subjectState.getCurrentContent()
  const rawSubjectState = convertToRaw(currSubjectContent)
  const subjectPlainText = currSubjectContent.getPlainText()
  const tokenizedSubject = tokenize(rawSubjectState.entityMap, subjectPlainText)

  return {
    body: _serializeRichBody(bodyState),
    subject: {
      rawState: rawSubjectState,
      text: tokenizedSubject.text,
      tokens: tokenizedSubject.tokens,
    },
  }
}

export const serializeMessage = (bodyState, { isEmail }) => {
  if (!isEmail) {
    const { text } = _serializePlainBody(bodyState)
    return text
  }
  const { text } = _serializeRichBody(bodyState)
  return text
}

function _serializeRichBody(bodyState) {
  const contentState = bodyState.getCurrentContent()
  const rawState = convertToRaw(contentState)
  const _bodyHTML = stateToHTML(contentState, getDefaultRichStyleConfig())
  const bodyHTML = `<div style="width: 600px font-family: sans-serif">${_bodyHTML}</div>`
  const { text, tokens } = tokenize(rawState.entityMap, bodyHTML)

  return {
    rawState,
    text,
    tokens,
  }
}

function _serializePlainBody(bodyState) {
  const contentState = bodyState.getCurrentContent()
  const rawState = convertToRaw(contentState)
  const plainText = contentState.getPlainText()
  const { text, tokens } = tokenize(rawState.entityMap, plainText)

  return {
    rawState,
    text,
    tokens,
  }
}



// WEBPACK FOOTER //
// ./src/services/draft-state/outgoing.js